import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';


const ThemeContext = createContext({ mode: 'light', toggleTheme: () => {} });

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem('zoometf_theme') || 'light');

  const toggleTheme = () => setMode((current) => (current === 'light' ? 'dark' : 'light'));

  useEffect(() => {
    document.documentElement.dataset.theme = mode;
    localStorage.setItem('zoometf_theme', mode);
  }, [mode]);

  const value = useMemo(() => ({ mode, toggleTheme }), [mode]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
